export enum eMapLocationType {
    STATION,
    RAV_KAV_STATION,
    PARK_AND_RIDE,
    LOCATION
}